<template>
  <v-data-table
    :headers="headers"
    :items="items"
    sort-by="id"
    class="elevation-1 dark-last-row punchlist"
    hide-default-footer
    item-key="id"
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="#004889"
      >
        <!--<v-toolbar-title class="white--text">Punchlist</v-toolbar-title>-->
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              tile
              small
            >
              <v-icon dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
          <v-card flat color="#004889">
            <v-card-title class="accent">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="warrantyform">
                  <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Task Title</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Task Title" rules="required">
                              <v-text-field
                                v-model="editedItem.title"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Assignee</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-select
                                v-model="editedItem.assignee"
                                :items="users"
                                item-text="name"
                                item-value="id"
                                clearable
                                solo
                                flat
                                dark
                            ></v-select>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Comments</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-textarea
                              v-model="editedItem.comments"
                              required
                              solo
                              flat
                              dark
                            ></v-textarea>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedItem.id != null">
                        <v-list-item-content>
                          <Images :job="editedItem.id" :key="`jip-${editedItem.id}`"/>
                        </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text> 

            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn large min-width="50%" color="primary" tile @click="editItem(item)">      
        <v-icon
        >
          mdi-pencil
        </v-icon>
      </v-btn>             
      <v-btn large min-width="50%" color="red" tile @click="deleteItem(item.id)">
        <v-icon
        color="white"
        >
        mdi-delete
      </v-icon>  
      </v-btn>  
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="getItems"
        tile
        :loading="loading"
      >
        No Items Found. Click Here to Refresh!
      </v-btn>
    </template>
    <template v-slot:item.checkbox="{ item }">
      <v-checkbox
        v-model="item.status"
        @change="completeTask(item)"
      ></v-checkbox>
    </template>
    <template v-slot:item.title="props">
      <v-edit-dialog
        :return-value.sync="props.item.title"
        @save="saveField(props.item.id)"
        large
      >
        <span class="line-through" v-if="props.item.status == true">{{ props.item.title }}</span>
        <span v-else>{{ props.item.title }}</span>
        <template v-slot:input>
          <v-text-field
            v-model="props.item.title"
            label="Edit"
            single-line
            counter
          ></v-text-field>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.assignee="props">
      <v-edit-dialog
        :return-value.sync="props.item.assignee"
        @save="saveField(props.item.id)"
        large
      >
        {{ getUsername(props.item.assignee) }}
        <template v-slot:input>
          <v-select
              v-model="props.item.assignee"
              :items="users"
              item-text="name"
              item-value="id"
              label="Assignee"
          ></v-select>
        </template>
      </v-edit-dialog>
    </template>
  </v-data-table>
</template>

<script>
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import mixin from '../../mixin/main.js'
    import Images from '../../components/Issues/PunchlistImage.vue'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin],
        props: ['job'],
        data: () => ({
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Status', value: 'checkbox', groupable: false, width: '100px' },
                {
                  text: 'Title',
                  align: 'start',
                  value: 'title',
                  sortable: false,
                  groupable: false,
                  width: '70%'
                },
                { text: 'Assignee', value: 'assignee', sortable: false },
                { text: 'Comments', value: 'comments', groupable: false, sortable: false },
                { text: 'Actions', value: 'actions', groupable: false, sortable: false, align: 'right' },
            ],
            items: [],
            editedIndex: -1,
            editedItem: {
                id: null,
                title: '',
                status: 0,
                assignee: '',
                comments: ''
            },
            defaultItem: {
                id: null,
                title: '',
                status: 0,
                assignee: '',
                comments: ''
            },
            search: null,
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
            Images
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Task' : 'Edit Task'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
           this.getItems()
        },

        methods: {
            getItems() {
                if(this.job) {
                    this.loading = true
                    axios.get('crm/ji/punchlist/get?id=' + this.job)
                        .then(response => {
                            this.loading = false
                            this.items = response.data.items
                            this.$nextTick()
                        })
                }
            },

            editItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = item
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('crm/ji/punchlist/delete?id=' + this.editedIndex)
                    .then(() => {
                      this.closeDelete()
                      this.getItems()
                      this.$nextTick()
                    })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/ji/punchlist/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getItems()
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      this.$set(this.editedItem, 'job', this.job)
                      axios.post('crm/ji/punchlist/add', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getItems()
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },
            saveField(id) {
              let item = this.items.filter(item => {
                return item.id == id
              })

              if(item.length) {
                axios.post('crm/ji/punchlist/update', item[0]).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.getItems()
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })     
              } 
            },
            completeTask(item) {
              let punchitem = this.items.filter(pitem => {
                return pitem.id == item.id
              })

              if(punchitem.length) {
                axios.post('crm/ji/punchlist/complete', punchitem[0]).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.getItems()
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })     
              } 
            },
        },
    }
</script>

<style lang="sass">
.line-through
  text-decoration: line-through

.v-row-group__header
  background: #1976d2!important

  .text-start 
    color: #fff

    button
      color: #fff!important

      &:last-child
        display: none!important

.punchlist
  tbody 
    tr
      &:not(v-row-group__header) 
        td
          &:not(.v-data-table__mobile-row)
            &:first-child 
              width: 50px!important

            &:nth-child(2)
              width: 70%!important
</style>